function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import { AdaptiveListener } from 'xps-react-utils';
import Select from '../Select';
import WebDropdown from './WebDropdown';

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onSelectChange", function (item) {
      var _this$props = _this.props,
          children = _this$props.children,
          onChange = _this$props.onChange;
      var selectedDropdownItem;
      React.Children.map(children, function (child, index) {
        if (Array.isArray(child.props.children)) {
          child.props.children.map(function (grandchild, grandindex) {
            if (grandchild.props.itemText === item) {
              selectedDropdownItem = _objectSpread(_objectSpread({}, grandchild), {}, {
                index: grandindex
              });
            }

            return null;
          });
        } else if (child.props.itemText === item) {
          selectedDropdownItem = _objectSpread(_objectSpread({}, child), {}, {
            index: index
          });
        }
      });
      onChange({
        value: selectedDropdownItem.props.value,
        index: selectedDropdownItem.index,
        itemText: selectedDropdownItem.props.itemText
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMobileSize", function () {
      return _this.updateSize('mobile');
    });

    _defineProperty(_assertThisInitialized(_this), "onTabletSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "onDesktopSize", function () {
      return _this.updateSize('desktop');
    });

    _defineProperty(_assertThisInitialized(_this), "buildSelectItem", function (child, index) {
      return {
        key: index,
        id: child.props.value,
        label: child.props.itemText
      };
    });

    _defineProperty(_assertThisInitialized(_this), "updateSize", function (size) {
      if (_this.node || _this.node2) {
        _this.setState({
          size: size
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "AdaptiveDropdown", function () {
      var _this$props2 = _this.props,
          buttonSize = _this$props2.buttonSize,
          dropdownKind = _this$props2.dropdownKind,
          id = _this$props2.id,
          name = _this$props2.name,
          nativeOnMobile = _this$props2.nativeOnMobile,
          size = _this$props2.size,
          defaultPageSize = _this$props2.defaultPageSize;
      var stateSize = _this.state.size;

      if (nativeOnMobile && stateSize === 'mobile' && dropdownKind === 'select') {
        // Quantum defect, do not observe, will break
        var _this$props3 = _this.props,
            children = _this$props3.children,
            defaultText = _this$props3.defaultText;
        var options = React.Children.map(children, function (child, index) {
          var newChild = {};

          if (Array.isArray(child.props.children)) {
            newChild.label = child.props.groupName;
            newChild.children = child.props.children.map(function (grandchild, grandindex) {
              return _this.buildSelectItem(grandchild, grandindex);
            });
          } else {
            newChild = _this.buildSelectItem(child, index);
          }

          return newChild;
        });
        return /*#__PURE__*/React.createElement(Select, {
          id: id,
          name: name,
          elementSize: buttonSize || size,
          ref: function ref(node) {
            _this.node2 = node;
          },
          options: options,
          onChangeValue: _this.onSelectChange,
          placeholder: defaultText
        });
      } else {
        var dropdownProps = _extends({}, _this.props);

        return /*#__PURE__*/React.createElement(WebDropdown, _extends({
          ref: function ref(node) {
            _this.node = node;
          },
          fieldID: id,
          size: buttonSize || size,
          defaultPageSize: defaultPageSize
        }, dropdownProps));
      }
    });

    _this.state = {};
    _this.node = null;
    _this.node2 = null;
    return _this;
  }

  _createClass(Dropdown, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(AdaptiveListener, {
        onMobileSize: this.onMobileSize,
        onTabletSize: this.onTabletSize,
        onDesktopSize: this.onDesktopSize
      }, /*#__PURE__*/React.createElement(this.AdaptiveDropdown, null));
    }
  }]);

  return Dropdown;
}(React.Component);

_defineProperty(Dropdown, "propTypes", {
  /** ID for dropdown input field  **REQUIRED FOR: 'dropdownKind="select"' */
  id: PropTypes.string,

  /** Add label for Dropdown select field */
  label: PropTypes.string,

  /** Display dropdown select label inside the field */
  inlineLabel: PropTypes.bool,

  /** Add description for Dropdown select field */
  description: PropTypes.string,

  /** Add error description for Dropdown select field */
  error: PropTypes.string,

  /** Set true if field is required */
  required: PropTypes.bool,

  /** Display optional next to the label */
  optional: PropTypes.bool,

  /** All direct descendant Elements or Components passed within the Dropdown Component (ie DropdownItem, DropdownGroup) */
  children: PropTypes.node,

  /** Classes to apply to the Dropdown Component */
  className: PropTypes.string,

  /** Default text of the Dropdown */
  defaultText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Match this 'value' prop to one of the DropdownItems' 'value' prop to select that item */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** indicates dropdown kind - 'select' or 'menu' behavior and accessibility roles */
  dropdownKind: PropTypes.oneOf(['select', 'menu']),

  /** Callback function on input type (event) or when dropdown item is selected (selectedItem info) */
  onChange: PropTypes.func,

  /** Toggle the state of the ItemList panel */
  open: PropTypes.bool,

  /** icon name for opening the dropdown */
  iconNameOpen: PropTypes.string,

  /** icon name for closing the dropdown */
  iconNameClose: PropTypes.string,

  /** Toggle disabled state of the Dropdown */
  disabled: PropTypes.bool,

  /** size of the dropdown field element for dropdownKind 'select' */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /** Style of the Button component for 'dropdownKind="menu"' */
  buttonKind: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'borderless']),

  /** indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName` */
  buttonIcon: PropTypes.oneOf(['right', 'left', 'none', 'only']),

  /** size of the button for dropdownKind 'menu'. */
  buttonSize: PropTypes.oneOf(['large', 'medium', 'small']),

  /** aria-label for menu button, used when menu button is icon only */
  buttonAriaLabel: PropTypes.string,

  /** custom dropdown label width. Default is 100% */
  labelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px) */
  panelWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** set dropdown panel height to allow vertical scrolling. Default is auto. */
  panelHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** indicates if you want to have the dropdown panel to align right */
  alignRight: PropTypes.bool,

  /** indicates if you want to have the dropdown panel to open up */
  dropUp: PropTypes.bool,

  /** indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page */
  dynamicDropDirection: PropTypes.bool,

  /** indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page */
  dynamicDropAlign: PropTypes.bool,

  /** indicates whether the dropdown should be a combo box with search type-ahead  */
  searchable: PropTypes.bool,

  /** Toggle to use 'Select' component for Mobile */
  nativeOnMobile: PropTypes.bool,

  /** Adaptive dropdown Mobile Select 'name'  */
  name: PropTypes.string,

  /** Set to true to have virtual/infinite scrolling without pagination */
  virtualScroll: PropTypes.bool,

  /** Number of rows of data for virtual scroll */
  defaultPageSize: PropTypes.number,

  /** Remove margin top above the input label */
  removeMarginTop: PropTypes.bool,

  /** Custom filter for searched text */
  customSearchFilter: PropTypes.func
});

_defineProperty(Dropdown, "defaultProps", {
  open: false,
  disabled: false,
  iconNameOpen: 'arrow_drop_down',
  iconNameClose: 'arrow_drop_up',
  onChange: function onChange() {},
  alignRight: false,
  dropUp: false,
  dynamicDropDirection: false,
  dynamicDropAlign: false,
  buttonKind: 'secondary',
  buttonIcon: 'right',
  value: null,
  size: 'small',
  dropdownKind: 'select',
  labelWidth: '100%',
  panelWidth: '100%',
  panelHeight: 'auto',
  searchable: false,
  required: false,
  nativeOnMobile: false,
  virtualScroll: false,
  defaultPageSize: 15
});

export { Dropdown as default };
Dropdown.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onSelectChange",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "item",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onMobileSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onTabletSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "onDesktopSize",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "buildSelectItem",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "child",
      "type": null
    }, {
      "name": "index",
      "type": null
    }],
    "returns": null
  }, {
    "name": "updateSize",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "size",
      "type": null
    }],
    "returns": null
  }, {
    "name": "AdaptiveDropdown",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "Dropdown",
  "props": {
    "open": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle the state of the ItemList panel"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle disabled state of the Dropdown"
    },
    "iconNameOpen": {
      "defaultValue": {
        "value": "'arrow_drop_down'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for opening the dropdown"
    },
    "iconNameClose": {
      "defaultValue": {
        "value": "'arrow_drop_up'",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "icon name for closing the dropdown"
    },
    "onChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Callback function on input type (event) or when dropdown item is selected (selectedItem info)"
    },
    "alignRight": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to align right"
    },
    "dropUp": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if you want to have the dropdown panel to open up"
    },
    "dynamicDropDirection": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should should open in the opposite direction (up or down) when it would otherwise go over the edge of the page"
    },
    "dynamicDropAlign": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates if the dropdown should align with the opposite side of its value field when it would otherwise go over the edge of the page"
    },
    "buttonKind": {
      "defaultValue": {
        "value": "'secondary'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'primary'",
          "computed": false
        }, {
          "value": "'secondary'",
          "computed": false
        }, {
          "value": "'tertiary'",
          "computed": false
        }, {
          "value": "'borderless'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Style of the Button component for 'dropdownKind=\"menu\"'"
    },
    "buttonIcon": {
      "defaultValue": {
        "value": "'right'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'right'",
          "computed": false
        }, {
          "value": "'left'",
          "computed": false
        }, {
          "value": "'none'",
          "computed": false
        }, {
          "value": "'only'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates whether the button should have an icon on left, right, none, or only if it's just an icon button without text. Must also pass `iconName`"
    },
    "value": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Match this 'value' prop to one of the DropdownItems' 'value' prop to select that item"
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of the dropdown field element for dropdownKind 'select'"
    },
    "dropdownKind": {
      "defaultValue": {
        "value": "'select'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'select'",
          "computed": false
        }, {
          "value": "'menu'",
          "computed": false
        }]
      },
      "required": false,
      "description": "indicates dropdown kind - 'select' or 'menu' behavior and accessibility roles"
    },
    "labelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown label width. Default is 100%"
    },
    "panelWidth": {
      "defaultValue": {
        "value": "'100%'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "custom dropdown panel width. Default is 100% on dropdownKind 'select'. Enter width number for dropdownKind 'menu' (suggested width: 240px)"
    },
    "panelHeight": {
      "defaultValue": {
        "value": "'auto'",
        "computed": false
      },
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "set dropdown panel height to allow vertical scrolling. Default is auto."
    },
    "searchable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "indicates whether the dropdown should be a combo box with search type-ahead"
    },
    "required": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set true if field is required"
    },
    "nativeOnMobile": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Toggle to use 'Select' component for Mobile"
    },
    "virtualScroll": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Set to true to have virtual/infinite scrolling without pagination"
    },
    "defaultPageSize": {
      "defaultValue": {
        "value": "15",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "Number of rows of data for virtual scroll"
    },
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "ID for dropdown input field  **REQUIRED FOR: 'dropdownKind=\"select\"'"
    },
    "label": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add label for Dropdown select field"
    },
    "inlineLabel": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display dropdown select label inside the field"
    },
    "description": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add description for Dropdown select field"
    },
    "error": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Add error description for Dropdown select field"
    },
    "optional": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Display optional next to the label"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": "All direct descendant Elements or Components passed within the Dropdown Component (ie DropdownItem, DropdownGroup)"
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Classes to apply to the Dropdown Component"
    },
    "defaultText": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false,
      "description": "Default text of the Dropdown"
    },
    "buttonSize": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'large'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'small'",
          "computed": false
        }]
      },
      "required": false,
      "description": "size of the button for dropdownKind 'menu'."
    },
    "buttonAriaLabel": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "aria-label for menu button, used when menu button is icon only"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Adaptive dropdown Mobile Select 'name'"
    },
    "removeMarginTop": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Remove margin top above the input label"
    },
    "customSearchFilter": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Custom filter for searched text"
    }
  }
};